/** Подання списку, яке відкриває збережене подання свого виду (прототип v4: таблиця → «Таблиця», дошка → «Беклог», картки → «Картки»). */
import type { SavedViewKind, StandardViewKey } from '@platform/core/types';

const VIEW: Partial<Record<SavedViewKind, StandardViewKey>> = { table: 'table', board: 'backlog', cards: 'cards', calendar: 'calendar' };

/** Подання для виду збереженого подання; «будь-яке» (any) — без переходу (undefined). Чиста функція. */
export function viewOfKind(kind: SavedViewKind): StandardViewKey | undefined {
  return VIEW[kind];
}
